module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "titlepage",
    attrs: {
      "epub:type": "titlepage"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_c('img', {
    attrs: {
      "alt": "Family Ties by Rowena Summers",
      "src": "images/scale~1920x1200~titlepatch-1554203778-37.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "canelo"
  }, [_c('img', {
    staticStyle: {
      "height": "30px",
      "width": "129px"
    },
    attrs: {
      "alt": "Canelo",
      "height": "30",
      "src": "images/scale~1920x1200~canelotitle-1454015556-29.png",
      "width": "129"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-601ab1d9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter0.vue
// module id = 63
// module chunks = 0